module.exports = __webpack_public_path__ + "static/media/download_icon.c906eb15.svg";